document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initScrollAnclas();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initScrollAnclas() {
  var ANCLAS = ['mt-como-funciona', 'mt-faq'];

  function irAAncla(id) {
    var el = document.getElementById(id);
    if (!el) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  if (location.hash) {
    var idActual = location.hash.replace('#', '');
    if (ANCLAS.indexOf(idActual) > -1) {
      irAAncla(idActual);
    }
  }

  document.querySelectorAll('a[href*="#mt-como-funciona"], a[href*="#mt-faq"]').forEach(function (link) {
    link.addEventListener('click', function (evt) {
      var url = new URL(link.href, window.location.href);
      var idDestino = url.hash.replace('#', '');
      if (ANCLAS.indexOf(idDestino) === -1) return;
      if (url.pathname === window.location.pathname) {
        evt.preventDefault();
        history.pushState(null, '', url.hash);
        irAAncla(idDestino);
      }
    });
  });
}

function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-mt-contador'));
      var sufijo = el.getAttribute('data-mt-sufijo') || '';
      var duracion = 1200;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var prog = Math.min((ts - inicio) / duracion, 1);
        var valor = Math.floor(prog * fin);
        el.textContent = valor + sufijo;
        if (prog < 1) requestAnimationFrame(paso);
        else el.textContent = fin + sufijo;
      }
      requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}
